<template>
  <div styleName="opt_home" @click="_hideContextMenu" @contextmenu.prevent="_ShowContextmenu">
    <SideMove :openStatus="rightSideOpen">
      <div styleName="opt_home_left">
        <ResizeWrapper>
          <Header/>
          <ToolBar :isShow="isShowToolBar" />
          <Footer />
        </ResizeWrapper>
      </div>
      <div styleName="opt_home_right" slot="aside">
        <PlayerBox/>
        <ChatBox styleName="chatbox" @changeRightSide="_changeRightSide" />
      </div>
    </SideMove>
    <SwitchBox>
      <InteractivePPT v-if="isPlayingVideo===1" />
      <VideoWrap v-show="isPlayingVideo===2" />
      <ShareWrap v-show="isPlayingVideo===3" />
      <SilentList/>
    </SwitchBox>
    <Player />
    <Hardware :show="alertStatus" @close="closeAlert" />
    <VideoBox />
    <ul styleName="menu" ref="menu" id="menu" v-if="showRightMenu" :style="menuStyle">
      <li styleName="menuItem" @click="_showClassAuthority">{{ $t('classroomLimit') }}</li>
    </ul>
    <ClassAuthorith />
  </div>
</template>
<script>
import style from './index.scss'
import CSSModules from 'vue-css-modules'
import InteractivePPT from '@/components/InteractivePPT'
import VideoWrap from '@/components/VideoWrap'
import Hardware from '@/components/HardwareSetting'
import VideoBox from '@/components/VideoBox'
import ClassAuthorith from '@/components/ClassAuthorith'
import Footer from '@/components/Footer'
import Player from '@/components/Player'
import PlayerBox from '@/components/PlayerBox'
import SwitchBox from '@/components/SwitchBox'
import Header from '@/views/Home/header'
import ToolBar from '@/components/Toolbar'
import SilentList from '@/components/SilentList'
import ChatBox from '@/components/ChatBox'
import SideMove from '@/components/SideMove'
import ResizeWrapper from '@/components/ResizeWrapper'
import ShareWrap from '@/components/ShareWrap'
import sensorLog from '@/utils/sensorLog'
import * as types from '@/constants'
import { mapGetters, mapActions } from 'vuex'
import { signalSdk, mediaSDK } from '@/utils/getSDK'
// import { iframeURL } from '@/config'

const SCREENHEIGHT = document.body.clientHeight || document.documentElement.clientHeight
const ELEWIDTH = 350
const ELEHEIGHT = 30

export default {
  name: 'home',
  mixins: [CSSModules(style)],
  components: {
    Header,
    ToolBar,
    InteractivePPT,
    Player,
    PlayerBox,
    SwitchBox,
    ChatBox,
    Footer,
    Hardware,
    SilentList,
    SideMove,
    ResizeWrapper,
    VideoWrap,
    VideoBox,
    ShareWrap,
    ClassAuthorith
  },
  data: function () {
    return {
      rightSideOpen: true,
      menuStyle: {},
      showRightMenu: false,
      isShowToolBar: true
    }
  },
  computed: {
    ...mapGetters(['roomDetail', 'alertStatus', 'isPlayingVideo', 'cssStyle', 'enterMediaRoom']),
  },
  // watch: {
  //   // enterMediaRoom (val) {
  //   //   let { status } = val.data
  //   //   if (status === 1) {
  //   //     // 计算页面加载时间
  //   //     window.performance.mark('pageLoading-end')
  //   //     window.performance.measure('pageLoading', 'pageLoading-start', 'pageLoading-end')

  //   //     let pageLoading = window.performance.getEntriesByName("pageLoading")
  //   //     let measureTime = 0
  //   //     if (pageLoading.length) {
  //   //       measureTime = pageLoading[0].duration
  //   //     }
  //   //     sensorLog.track("enterRoom_finish", types.SENSORLOG.type.INIT, JSON.stringify({
  //   //       launch_time: measureTime
  //   //     }))
  //   //     window.performance.clearMarks()
  //   //     window.performance.clearMeasures()
  //   //   }
  //   // }
  // },
  mounted () {
    // 监听被踢
    signalSdk.on('USER_ROOM_KICKOFF', () => {
      sensorLog.track("signal_error", types.SENSORLOG.type.FAILED, 'USER_ROOM_KICKOFF')
      mediaSDK.closeMedial().then(() => {
        this.exitMediaSDK()
      })
      this.exitSignalSDK()
      this.$toast.show({
        text: this.$t('kickOut'),
        headerDesc: this.$t('attention'),
        buttonCount: 1,
        textStyle: {
          textAlign: 'center'
        },
        btnText: this.$t('loginAgain'),
        btnOK: () => {
          // console.log('window.top.location.origin-->', window.top.location.href)
          // 将消息传入外层window刷新
          // window.top.postMessage('reload', window.top.location.origin)
          window.location.reload()
        }
      })
    })
    // 监听token出错
    signalSdk.on('USER_SIGNAL_EXCEPTION', (reason) => {
      let desc = ''
      if (reason === 'TOKEN_ERROR') {
        desc = this.$t('tokenError')
      } else if (reason === 'NET_EXCEPTION') {
        desc = this.$t('networkError')
      } else if (reason === 'SERVER_EXCEPTION') {
        desc = this.$t('serverError')
      }
      this.$toast.show({
        text: desc || 'signal error ! please refresh again!',
        headerDesc: this.$t('attention'),
        buttonCount: 1,
        textStyle: {
          textAlign: 'center'
        },
        btnText: this.$t('btnok'),
        btnOK: () => {
          window.location.reload()
        }
      })
      sensorLog.track("signal_error", types.SENSORLOG.type.FAILED, reason)
    })

    mediaSDK.on('ROOM_DISCONNECTED', (reason) => {
      sensorLog.track("media_error", types.SENSORLOG.type.FAILED, reason)
      this.$toast.show({
        text: 'video error,please try again',
        headerDesc: this.$t('attention'),
        buttonCount: 1,
        textStyle: {
          textAlign: 'center'
        },
        btnText: this.$t('btnok'),
        btnOK: () => {
          window.location.reload()
        }
      })
    })
  },
  beforeDestroy () {
    this.isPlayingVideo === 2 && signalSdk.sendCloseVideoMP4()
  },
  methods: {
    ...mapActions([
      'exitMediaSDK',
      'exitSignalSDK',
    ]),
    _changeRightSide (bool) {
      this.rightSideOpen = bool
    },
    closeAlert () {
      this.$store.commit(types.ALERT_STATUS, false)
    },
    _ShowContextmenu (e) {
      let { pageX, pageY } = e
      let left, top
      if (pageX < ELEWIDTH) {
        left = `${pageX}px`
      } else {
        left = `${pageX - ELEWIDTH}px`
      }
      if (pageY + ELEHEIGHT > SCREENHEIGHT) {
        top = `${pageY - ELEHEIGHT}px`
      } else {
        top = `${pageY}px`
      }
      this.menuStyle = {
        left,
        top
      }
      this.showRightMenu = true
    },
    _hideContextMenu (e) {
      if (e.target.id !== 'menu' || e.target.parentNode.id !== 'menu') {
        this.showRightMenu = false
      }
    },
    _showClassAuthority () {
      this.$store.dispatch('switchModalStatus', true)
    }
  }
}
</script>
